(function () {
  // product gallery: arrows, thumbs, counter, swipe hint
  document.querySelectorAll('[data-sw-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var cur = g.querySelector('[data-cur]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-go]'));
    function at() {
      var best = 0, bd = Infinity;
      slides.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function set() {
      var i = at();
      if (cur) cur.textContent = i + 1;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
      g.classList.toggle('at-start', i === 0);
      g.classList.toggle('at-end', i === slides.length - 1);
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(set); }, { passive: true });
    var p = g.querySelector('[data-prev]'), n = g.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { go(at() - 1); });
    if (n) n.addEventListener('click', function () { go(at() + 1); });
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    g.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(at() + 1); if (e.key === 'ArrowLeft') go(at() - 1); });
    set();
  });

  // home: the hang tag of the piece in the middle of the screen gives a little nudge
  var cells = document.querySelectorAll('.v3-room .v3-cell');
  if (cells.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-center', e.isIntersecting); });
    }, { rootMargin: '-38% 0px -38% 0px' });
    cells.forEach(function (c) { io.observe(c); });
  }
})();
